import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/dots.svg'


const _withScopeId = n => (_pushScopeId("data-v-54b83bce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-menu-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-menu__title" }, "МЕНЮ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "section-menu__dots"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "section-menu__line" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "menu-list"
}
const _hoisted_7 = { class: "item__icon" }
const _hoisted_8 = { class: "item__title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item__icon--delivery_zones" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__title" }, "Зоны доставки", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-menu section-menu--mobile" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "section-menu__line" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["section-menu section-menu--desktop", { 'section-menu--opened': _ctx.isOpen }])
    }, [
      (!_ctx.isOpen)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: "section-menu__title-wrapper",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu(true)))
            }, _hoisted_4),
            _hoisted_5
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.title,
                to: item.routeSettings,
                class: "item"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: _normalizeClass(` item__icon--${item.icon}`)
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128)),
            (_ctx.hasDeliveryZone)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'c-delivery-zones' },
                  class: "item"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu()))
          }))
        : _createCommentVNode("", true)
    ], 2),
    _hoisted_11
  ]))
}